// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { firestorePlugin } from 'vuefire'
import PaginaCarregando from '@/components/PaginaCarregando.vue'
import store from './store/store'
import VueSimpleAlert from 'vue-simple-alert'
import VueMask from 'v-mask'
import VueCountdown from '@chenfengyuan/vue-countdown'
import VueCrontab from 'vue-crontab'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

dom.watch()
library.add(fas)
library.add(fab)
library.add(far)
Vue.component(VueCountdown.name, VueCountdown)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('PaginaCarregando', PaginaCarregando)
Vue.use(firestorePlugin)
Vue.use(VueSimpleAlert)
Vue.use(VueMask)
Vue.use(Loading)
Vue.use(VueCrontab)
Vue.use(VueAnalytics, {
  id: 'UA-101862814-1',
  router,
  checkDuplicatedScript: true
})

const moment = require('moment')
require('moment/locale/pt-br')
Vue.use(require('vue-moment'), {
  moment
})

Vue.filter('numeroPreco', valor => {
  valor = Number(valor)
  if (!isNaN(valor)) {
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })
  } else {
    return ''
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js